import { clientWithoutInterceptors } from '../utils/http';

export async function getHasCashflow(): Promise<Response> {
  const response = await clientWithoutInterceptors.get('/api/cashflows/meta/v2/has-cashflow');
  return response.data;
}
